// extracted by mini-css-extract-plugin
export default {"FailedJobs":"FailedJobs_FailedJobs__C5oXm"};